
import GwExpander from '~/patterns/molecules/expander/expander.vue';
export default {
    components: {
        GwExpander,
    },
    props: {
        numberOfEditions: {
            type: Number,
            default: 0
        },
        showClearFilters: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        clearFilters() {
            this.$emit('clearFilters');
        }
    }
};
